module.exports = __webpack_public_path__ + "img/s3.8f3731a7.svg";